import React from "react";
import { Route, Link, withRouter } from "react-router-dom";
import { updateProjectDetails } from "../../util/project_api_util"

class AddPayoutModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      errors: [],
      bonus_payout: props.package.bonus_payout,
    }
    this.handleInput = this.handleInput.bind(this)
    this.submitBonusPayout = this.submitBonusPayout.bind(this)
  }

  componentDidMount() {
    document.body.style.overflow = 'hidden';
  }

  componentWillUnmount() {
    document.body.style.overflow = 'unset';
  }

  handleInput(field) {
    return e => this.setState({ [field]: e.currentTarget.value });
  }

  submitBonusPayout() {
    let data = { id: this.props.project.id, project: { id: this.props.project.id, packages_attributes: {bonus_payout: this.state.bonus_payout, id: this.props.package.id} } }

    updateProjectDetails(data).then(() => {
      this.props.onClose()
      this.props.onPayoutAdded()
    })
  }

  render() {
    return (
      <div className="modal-background">
        <div className="orderpreviewModal" onClick={e => e.stopPropagation()}>
          <div className="orderPreviewModalComponent">
            <div className="uploadPhotoModalHeadingGroup">
              <div className="uploadPhotoModalHeading">Bonus Payout</div>
              <div className="closeIcon" onClick={() => this.props.onClose()}><i className="fas fa-times"></i></div>
            </div>
            <div className="settingsCategoryGroup1">
              <div className="settingsServicesInput">
                <label id="formLabel"></label>
                <input className="formInput" onChange={this.handleInput("bonus_payout")} type="number" placeholder="Enter payout" value={this.state.bonus_payout} />
              </div>
            </div>
            <div className="reviewModalSubmitButton">
              <button onClick={this.submitBonusPayout} className="settingsButton">Submit</button>
            </div>
          </div>
          <div className="modalMobilePushup"></div>
        </div>
      </div>
    )
  }
}

export default withRouter(AddPayoutModal);